import 'whatwg-fetch';
import querystring from 'querystring';
import fetchJsonp from 'fetch-jsonp';
import { getVisitorHeaders } from '../visitorContext.js';

// import moment from 'moment';

function apiUrl(path) {
  if (import.meta.env.PROD) {
    return `https://gdetotam.org:10006${path}`;
  }
  return path;
}

async function apiFetch(path, options = {}) {
  const headers = {
    ...getVisitorHeaders(),
    ...(options.headers || {}),
  };
  return fetch(apiUrl(path), { ...options, headers });
}

let API = {
  fetchAirports() {
    return fetch('/airports.json').then((response) => response.json());
  },

  async clientGeoIp() {
    try {
      const response = await apiFetch('/api/geoip');
      return response ? response.json() : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  async fetchTravels(state) {
    let oprions = {
      q: state.fromAirportCode,
      period: state.startDate,
      min_duration: state.minDays,
      max_duration: state.maxDays
    };

    if (!state.fromAirportCode || state.fromAirportCode.length < 2) {
      console.log("fetchTravels: Invalid input data: ", state);
      return [];
    }

    let generated = querystring.stringify(oprions);

    try {
      const response = await apiFetch(`/api/travels?${generated}`);
      console.log("fetch response: ", response);
      return response ? response.json() : '';
    }
    catch (error) {
      console.log("Fetch error: ", error);
      return '';
    }
  },

  async fetchDestinationInfo(params) {
    const generated = querystring.stringify(params);
    try {
      const response = await apiFetch(`/api/destination-info?${generated}`);
      if (!response || !response.ok) {
        return null;
      }
      return response.json();
    } catch (error) {
      console.error('fetchDestinationInfo error:', error);
      return null;
    }
  },

  async fetchTravelataAccommodation(params) {
    const generated = querystring.stringify(params);
    try {
      const response = await apiFetch(`/api/travelata/accommodation?${generated}`);
      if (!response || !response.ok) {
        return { success: false, tours: [] };
      }
      return response.json();
    } catch (error) {
      console.error('fetchTravelataAccommodation error:', error);
      return { success: false, tours: [] };
    }
  },

  async nearby(latitude, longitude, len) {
    let oprions = {latitude, longitude, len};
    let generated = querystring.stringify(oprions);

    try {
      const response = await apiFetch(`/api/nearby?${generated}`);
      return response ? response.json() : '';
    }
    catch (error) {
      console.error(error);
      return [];
    }
  },

  async getAutoComplete(val) {
    // http://autocomplete.travelpayouts.com/places2?term=Mos&locale=en&types[]=country&callback=function

    let oprions = {
      term: val,
      locale: 'en',
      types: [
        'airport'
        // 'city', 'airport', 'country'
      ],
      // callback: 'function'
    };

    let generated = querystring.stringify(oprions);
    let url3 = `https://autocomplete.travelpayouts.com/places2?${generated}`;

    return fetchJsonp(url3, {timeout: 10000}).then(function (response) {
      return response.json();
    }).then((json) => {
      console.log('getAutoComplete json', json);
      return json ? json : '';
    }).catch((error) => {
      console.error("getAutoComplete error:", error);
      return [];
    });
  },

  async getBySearch(val) {
// http://autocomplete.travelpayouts.com/places2?term=Mos&locale=en&types[]=country&callback=function

    let oprions = {
      q: val,
      locale: 'en'
      // callback: 'function'
    };

    let generated = querystring.stringify(oprions);
    let url3 = `https://autocomplete.travelpayouts.com/jravia?${generated}`;

    return fetchJsonp(url3, {timeout: 10000}).then(function (response) {
      return response.json();
    }).then(function (json) {
      console.log('getBySearch json', json);
      return json ? json : '';
    }).catch(error => {
      console.error("getBySearch error:", error);
      return [];
    });
  }
};

export default API;
